// removed by extract-text-webpack-plugin
module.exports = {"badges":"badgesContainer__badges___2IrR4","gradient":"badgesContainer__gradient___1Co7F","reqInfo":"badgesContainer__reqInfo___jtJmE"};


//////////////////
// WEBPACK FOOTER
// ./components/Scoreboard/badgesContainer.scss
// module id = ./components/Scoreboard/badgesContainer.scss
// module chunks = 5